import { Controller } from "@hotwired/stimulus"

 export default class extends Controller {              
   static targets = [ "toggleable" ]                    

   // Toggle the hidden class on the dropdown
    toggle() {
        this.toggleableTarget.classList.toggle('hidden')
    }                                                  
 }